/* eslint-disable max-len */
/**
 * Italian translations.
 */
export default {
  ACTION: {
    CANCEL: 'Annulla',
    CONFIRM: 'Conferma',
    CONFIRM_POLL_RESPONSE: 'Conferma risposta',
    CONTINUE: 'Continuare',
    COPY: 'Copia',
    DELETE: 'Elimina',
    DELETE_MESSAGE: 'Elimina messaggio',
    EDIT: 'Modifica',
    FINISH: 'Finire',
    HIDE_ANSWERS: 'Nascondi le risposte',
    LETS_GET_STARTED: 'Certo, cominciamo!',
    MARK_AS_UNREAD: 'Segna come non letto',
    REPLY: 'Rispondi',
    SEE_ANSWERS: 'Vedi le risposte',
    START_SURVEY: 'Inizia il sondaggio'
  },
  ERROR: {
    ASSET_SIZE_EXCEEDED: 'La dimensione massima di un file è {size}MB',
    CLASSIFICATION_ALREADY_IN_USE:
      'Il sondaggio è scaduto perché esiste già una campagna per questa categoria.',
    ERROR_CREATING_NEW_SUGGESTION:
      'Errore durante la creazione di una nuova offerta',
    ERROR_SAVING_PRODUCT_REVIEW:
      'Problemi a salvare la valutazione del prodotto',
    ERROR_SENDING_MESSAGE: 'Errore nell\'invio del messaggio',
    ERROR_SUBMITTING_SURVEY: 'Errore durante l\'invio del sondaggio',
    IMAGE_SIZE_EXCEEDED: 'La dimensione massima di un\'immagine è {size}MB',
    MESSAGE_ALREADY_READ:
      'Questo messaggio non può più essere modificato perché è già stato letto.',
    UPLOADED_ASSETS_EXCEED: 'Il numero massimo di file è {limit}',
    VIDEO_SIZE_EXCEEDED: 'La dimensione massima di un video è {size}MB'
  },
  HEADER: {},
  LABEL: {
    ACTIONS: 'Azioni',
    ADDITIONAL_COMMENTS_QUESTION: 'Hai qualcosa da aggiungere?',
    ANSWERED_ON: 'Risposta a {date}',
    CONTACT_OWNER: 'Qualcosa è andato storto. Contatta il tuo responsabile',
    CREATE_NEW_CAMPAIGN_SUGGESTION: 'Clicca qui per generare una nuova offerta',
    EDITED: 'Modificato',
    EXPIRED_ON: 'È scaduto il {date}',
    LAST_READ: 'Ultima lettura',
    POLL_CAMPAIGN_EXPIRED: 'ℹ️ Offerta scaduta',
    POLL_CAMPAIGN_FOOTER:
      'ℹ️ Accettando, la campagna verrà creata con inizio da domani.\nRiceverai anche domani il messaggio con il poster da condividere.\nQuesta offerta sarà disponibile per 3 giorni.',
    QUANTITY: 'Quantità',
    REACT: 'Reagisci',
    REACTIONS: 'Reazioni',
    RESPOND_BY: 'Rispondi entro {date}',
    SEE_PRODUCTS: 'Vedi prodotti',
    SEEN: 'Visto',
    SELECT_ADDRESS: 'Seleziona indirizzo',
    SELECT_ONE_OPTION: 'Scegli un\'opzione',
    SELECT_ONE_OR_MORE_OPTION: 'Scegli una o più opzioni',
    SENT: 'Inviato',
    SWIPE_TO_CANCEL: 'Scorrere per annullare',
    TYPE_NEW_MESSAGE: 'Scrivi un nuovo messaggio',
    VOICE_MESSAGE: 'Messaggio vocale'
  },
  SENTENCE: {
    CONFIRM_POLL_INTERNAL_ORDER:
      'Questa azione confermerà l\'ordine e non sarà possibile modificare la risposta. Vuoi continuare?',
    DELETE_MESSAGE_CONFIRM: 'Sei sicuro di voler eliminare questo messaggio?',
    GIVE_OPINION_ABOUT_PRODUCT: 'Puoi dirci cosa ne pensi di questo prodotto?',
    MESSAGE_DELETED: 'Questo messaggio è stato eliminato'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
